import type React from 'react'
import type { IconProps } from './types'

const ArrowUpIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M13 20L13 7.825L18.6 13.425L20 12L12 4L4 12L5.4 13.425L11 7.825L11 20H13Z' />
	</svg>
)

export default ArrowUpIcon
